// extracted by mini-css-extract-plugin
module.exports = {"scale":"timescale_scale__3zOss","fragment":"timescale_fragment__ZOo31","cursor":"timescale_cursor__3LCIn"};